import { environment } from '@environments/environment';

export const GET_FURNITURES_IMAGE_NAME_DESCRIPTION_FILTER_QUERY = (langcode: string, productType: string) => ({
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_finitions,
  body: {
    size: 10000,
    query: {
      bool: {
        filter: [
          {
            term: {
              search_api_datasource: 'entity:taxonomy_term',
            },
          },
          {
            term: {
              vid: 'categorie_des_meubles',
            },
          },
          {
            term: {
              search_api_language: langcode,
            },
          },
          {
            term: {
              field_categorie_type_meuble: productType,
            },
          },
        ],
      },
    },
    _source: ['name'],
  },
});
